module.exports = __webpack_public_path__ + "static/media/neon-pink.4c4eb750.png";